$(document).on("turbolinks:load", function () {

  if ($('.specific_booking_slot').is('*')) {
    $('.specific_booking_slot a').addClass('active');
  }

 });

